import { UseQueryResult, useQuery } from 'react-query';
import { getUserById } from 'src/api/organization';
import { OrgUser } from 'src/stores/OrgUserStore';

export const orgUserByIdKey = 'orgUserById';

export const useOrganizationUserById = (userId: number): UseQueryResult<OrgUser> => {
    return useQuery({
        queryKey: [orgUserByIdKey, userId],
        queryFn: async () => {
            return await getUserById(userId);
        },
        enabled: !!userId,
        initialData: null,
    });
};
